import { ListingCardShimmer } from './ListingCardShimmer'

export default ListingCardShimmer
